//
// DiscreteAxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "./AxisTickValueFitPolicy";
import "../core/SortOrder";
import "./DiscreteAxisTickPosition";
import "./AxisTickValueListPolicy";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./DiscreteAxisTickValueAppearance";
import "./AxisColorBands";
import "../core/styles/FillAttributes";
import "../core/Justification";
import "./AxisTickValueRotation";

var DiscreteAxisOptions = createModule("gtl_DiscreteAxisOptions", [130,13,20148,20111], EventDispatcher, [
    ,
    {
        maxTickSpacing: 1,
        tickType: 4,
        colorBands: 4,
        tickDisplayList: [7],
        tickValueListPolicy: 4,
        tickValueSplitCharDrop: 2,
        tickValueSplitJustify: 4,
        tickValueAppearance: 4,
        sortOrder: 4,
        colorBandsAttributes: 1,
        tickSpacing: 1,
        tickValueFitPolicy: 4,
        tickValueList: [7],
        tickValueSplitChar: 7,
        tickValueRotation: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DiscreteAxisOptions;
